<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.charge_asyncCharges')"
    width="1000px"
    :close-on-click-modal="false"
    class="app-main-inner"
    :append-to-body="true"
  >
    <div style="display: flex;margin-bottom: 10px">
      <el-button type="primary" @click="passAudit">{{ $t('SeaExport.PassAudit') }}</el-button>
      <el-button @click="setReaded">{{ $t('FinanceManage.markAsRead') }}</el-button>
      <el-button type="danger" @click="notPassAudit">{{ $t('FinanceManage.fail') }}</el-button>
      <div style="margin-left: auto;">
        <el-button type="danger" @click="applyRecallCharge">{{ $t('FinanceManage.applyRecallCharge') }}</el-button>
      </div>
    </div>
    <cargo-ag-grid
      config-module="13011102"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width: 100%;min-height: 350px;"
      @gridReady="params=>{gridApi=params.api}"
    />
    <!--拒绝-->
    <reject-dialog
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :reject-call-back="rejectWindow.rejectCallBack"
      :append-to-body="true"
    />
    <!--  申请撤销  -->
    <sync-charge-apply-recall
      :recall-charges="syncChargeApplyRecall.recallCharges"
      :visible.sync="syncChargeApplyRecall.visible"
      :apply-call-back="syncChargeApplyRecall.applyCallBack"
      @close="syncChargeApplyRecall.visible = false"
    />
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import {
  queryChargeSyncRecord,
  passChargeSync,
  updateChargeSyncRecordRead,
  notPassChargeSync,
  updateChargeSyncRecallState, passChargeSyncRecall, notPassChargeSyncRecall, getJobByUuid
} from '@/api/booking/job'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import rejectDialog from '@/views/cargo/v0/AirExport/components/verify/rejectDialog.vue'
import syncChargeApplyRecall from '@/components/Cargo/Job/syncChargeApplyRecall'
import { getTrustFromCharges, loadCharges } from '@/api/clearing/charge'

export default {
  name: 'ChargeSyncRecordDialog',
  components: { rejectDialog, syncChargeApplyRecall },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    chargeSyncCheckJobState: { type: Array, default: null },
    location: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.receivablePayable'),
          colId: 'receivable',
          field: 'receivable',
          width: 120,
          valueFormatter: params => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.sender'),
          field: 'sender',
          width: 80,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('FinanceManage.receiver'),
          field: 'receiver',
          width: 80,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('FinanceManage.currency'),
          colId: 'currency',
          field: 'currency',
          width: 180
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'),
          colId: 'amount',
          field: 'amount',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxExcludedPrice'),
          colId: 'excludingTaxAmount',
          field: 'excludingTaxAmount',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxAmount'),
          colId: 'taxAmount',
          field: 'taxAmount',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'),
          colId: 'taxRate',
          field: 'taxRate',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'),
          colId: 'unitRate',
          field: 'unitRate',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          colId: 'oversea',
          field: 'oversea',
          width: 180,
          valueFormatter: params => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          }
        },
        {
          headerName: this.$t('FinanceManage.syncProgress'),
          colId: 'syncProgress',
          field: 'syncProgress',
          width: 180,
          cellRenderer: params => {
            const text = ColumnUtils.chargeSyncProgrssLabelFunc(params.value)
            if (params.value === ChargeConstants.THE_OTHER_PARTY_HAS_REFUSED.code) {
              return `<span style="color: red">${text}</span>`
            }
            return text
          }
        },
        {
          headerName: this.$t('FinanceManage.processingStatus'),
          colId: 'handlingStatus',
          field: 'handlingStatus',
          width: 180,
          valueFormatter: params => {
            let text = params.value ? this.$t('CargoMsg.Cargo_Handled') : this.$t('FinanceManage.pending')
            if (params.data.syncProgress !== ChargeConstants.TO_BE_CONFIRMED_BY_US.code && params.data.syncProgress !== ChargeConstants.TO_BE_CONFIRMED_BY_OTHER_PARTY.code) {
              text += `（${params.data.read ? this.$t('FinanceManage.alreadyRead') : this.$t('FinanceManage.notRead')}）`
            }
            return text
          }
        },
        {
          headerName: this.$t('FinanceManage.sendingTime'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 180
        },
        {
          headerName: this.$t('FinanceManage.auditOperationTime'),
          colId: 'verifiedTime',
          field: 'verifiedTime',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          colId: 'warehouseNo',
          field: 'warehouseNo',
          width: 180
        },
        {
          headerName: 'SO No.',
          colId: 'soNo',
          field: 'soNo',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.Unit'),
          colId: 'measure',
          field: 'measure',
          width: 180
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DenialReason'),
          colId: 'rejectReason',
          field: 'rejectReason',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.source'),
          colId: 'syncSource',
          field: 'syncSource',
          width: 180,
          cellRenderer: params => {
            let text = this.$t('SeaExport.ConsignationSI')
            if (params.value === 1) {
              text = this.$t('SeaExport.Consignation')
            }
            return text
          }
        },
        {
          headerName: this.$t('FinanceManage.recallState'),
          colId: 'recallProgress',
          field: 'recallProgress',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.chargeSyncRecallStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.recallCause'),
          colId: 'recallCause',
          field: 'recallCause',
          width: 180
        }
      ],
      rowData: [],
      gridApi: null,
      refreshCharge: false,
      rejectWindow: {
        visible: false,
        jobNo: null,
        rejectCallBack: null
      },
      syncChargeApplyRecall: {
        visible: false,
        recallCharges: [],
        applyCallBack: null
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.refreshCharge = false
          this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.$emit('callback', this.refreshCharge)
        this.rowData = []
      }
    }
  },
  methods: {
    init() {
      queryChargeSyncRecord({ jobKey: this.job.uuid }).then(res => {
        this.rowData = res.data
      })
    },
    async passAudit() {
      const loading = getLoading4Cxt(this)
      const selectedRows = this.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        loading.close()
        return false
      }
      const recallRows = selectedRows.filter(p => p.recallProgress === ChargeConstants.WE_RECALL_TO_BE_REFUSED.code)
      const auditRows = selectedRows.filter(p => p.syncProgress === ChargeConstants.TO_BE_CONFIRMED_BY_US.code)
      if (auditRows && auditRows.length > 0 && recallRows && recallRows.length > 0) {
        this.$message.warning(this.$t('FinanceManage.PleaseSeparateTheFeesForConfirmationAndWithdrawal'))
        loading.close()
        return
      }
      let func = passChargeSync
      if (recallRows && recallRows.length > 0) {
        if (!await this.checkApplyRecallCharge(recallRows, true)) {
          loading.close()
          return
        }
        func = passChargeSyncRecall
      } else {
        if (this.chargeSyncCheckJobState) {
          if (!this.chargeSyncCheckJobState.includes(this.job.jobState)) {
            this.$message.warning(this.$t('Message.ChargeSyncJobStateCheckFail'))
            loading.close()
            return
          }
        } else {
          if (this.job.jobState !== 0) {
            this.$message.warning(this.$t('FinanceManage.businessHasBeenSubmitted'))
            loading.close()
            return
          }
        }
        if (!this.checkConfirmedData()) {
          loading.close()
          return
        }
      }
      const keys = Array.from(selectedRows, p => p.uuid)
      func(keys, { location: this.location, jobUuid: this.job.uuid }).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.init()
        this.refreshCharge = true
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    checkConfirmedData() {
      const selectedRows = this.gridApi.getSelectedRows()
      const keys = []
      let flag = selectedRows.length > 0
      if (flag) {
        for (const row of selectedRows) {
          if (row.syncProgress !== ChargeConstants.TO_BE_CONFIRMED_BY_US.code) {
            flag = false
            break
          }
          keys.push(row.uuid)
        }
      }
      if (flag) {
        flag = keys.length > 0
      }
      // CARGO-30570 不能对单条费用审核通过
      // if (flag) {
      //   const pendingCount = this.rowData.filter(p => p.syncProgress === ChargeConstants.TO_BE_CONFIRMED_BY_US.code).length
      //   if (keys.length !== pendingCount) {
      //     flag = false
      //   }
      // }
      if (!flag) {
        this.$message.warning(this.$t('FinanceManage.selectBeConfirmedChargeByUs'))
      }
      return flag
    },
    setReaded() {
      const selectedRows = this.gridApi.getSelectedRows()
      const keys = []
      for (const row of selectedRows) {
        if (row.syncProgress === ChargeConstants.THE_OTHER_PARTY_HAS_REFUSED.code && !row.handlingStatus) {
          keys.push(row.uuid)
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('FinanceManage.selectRejectedChargeByOppositeParty'))
        return
      }
      updateChargeSyncRecordRead(keys).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.init()
      })
    },
    notPassAudit() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return false
      }
      const recallRows = selectedRows.filter(p => p.recallProgress === ChargeConstants.WE_RECALL_TO_BE_REFUSED.code)
      const auditRows = selectedRows.filter(p => p.syncProgress === ChargeConstants.TO_BE_CONFIRMED_BY_US.code)
      if (auditRows && auditRows.length > 0 && recallRows && recallRows.length > 0) {
        this.$message.warning(this.$t('FinanceManage.PleaseSeparateTheFeesForConfirmationAndWithdrawal'))
        return
      }
      if (!recallRows || recallRows.length === 0) {
        if (!this.checkConfirmedData()) {
          return
        }
      }
      this.rejectWindow.jobNo = this.job.jobNo
      this.rejectWindow.rejectCallBack = this.rejectFunc
      this.rejectWindow.visible = true
    },
    async rejectFunc(reason) {
      if (!reason) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ReasonNotEntered'))
        return false
      }
      const selectedRows = this.gridApi.getSelectedRows()
      const auditRows = selectedRows.filter(p => p.syncProgress === ChargeConstants.TO_BE_CONFIRMED_BY_US.code)
      let func = notPassChargeSync
      if (!auditRows || auditRows.length === 0) {
        func = notPassChargeSyncRecall
      }
      const keys = Array.from(selectedRows, p => p.uuid)
      func(keys, { reason: reason, jobUuid: this.job.uuid }).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.init()
        this.refreshCharge = true
      })
    },
    async applyRecallCharge() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return false
      }
      if (!await this.checkApplyRecallCharge(selectedRows, false)) {
        return
      }
      this.syncChargeApplyRecall.recallCharges = selectedRows
      this.syncChargeApplyRecall.applyCallBack = this.recallConfirm
      this.syncChargeApplyRecall.visible = true
    },
    recallConfirm(rows) {
      const updateRows = []
      for (const row of rows) {
        updateRows.push({
          uuid: row.uuid,
          senderRecall: this.job.opOffice,
          receiverRecall: row.sender === this.job.opOffice ? row.receiver : row.sender,
          senderRecallState: ChargeConstants.TO_BE_RECALL_TO_BE_REFUSED.code,
          receiverRecallState: ChargeConstants.WE_RECALL_TO_BE_REFUSED.code,
          recallCause: row.recallCause
        })
      }
      const loading = getLoading4Cxt(this)
      updateChargeSyncRecallState(updateRows).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.init()
        this.refreshCharge = true
      }).finally(() => {
        loading.close()
      })
    },
    async checkApplyRecallCharge(selectedRows, isAudit = false) {
      if (isAudit) {
        if (this.job.jobState !== 0) {
          this.$message.warning(this.$t('Message.ChargeSyncJobStateCheckFail'))
          return false
        }
        let targetJobUuid = selectedRows[0].senderJobUuid
        if (this.job.uuid === targetJobUuid) {
          targetJobUuid = selectedRows[0].receiverJobUuid
        }
        const targetJob = await getJobByUuid(targetJobUuid).then(res => res.data)
        if (targetJob.jobState !== 0) {
          this.$message.warning(this.$t('Message.ChargeSyncJobStateCheckFail'))
          return false
        }
      }
      const chargeKeys = Array.from(selectedRows, p => p.chargeUuid)
      const jobKeys = Array.from(selectedRows, p => p.receiverJobUuid)
      const charges = await loadCharges({ chargeKeys: chargeKeys }).then(res => { return res.data }).finally(() => {})
      const trustFromCharges = await getTrustFromCharges({ chargeKeys: chargeKeys, jobKeys: jobKeys }).then(res => { return res.data }).finally(() => {})
      for (const row of selectedRows) {
        if (!isAudit && row.syncProgress !== ChargeConstants.WE_HAVE_CONFIRMED.code && row.syncProgress !== ChargeConstants.THE_OTHER_PARTY_HAS_CONFIRMED.code) {
          this.$message.warning(this.$t('FinanceManage.youCanOnlyOperateOnConfirmedCharges'))
          return false
        }
        if (!isAudit && (row.recallProgress === ChargeConstants.WE_RECALL_TO_BE_REFUSED.code || row.recallProgress === ChargeConstants.TO_BE_RECALL_TO_BE_REFUSED.code || row.recallProgress === ChargeConstants.WE_RECALL_HAVE_CONFIRMED.code || row.recallProgress === ChargeConstants.THE_OTHER_RECALL_HAVE_CONFIRMED.code)) {
          this.$message.warning(this.$t('FinanceManage.thereAreCostsThatHaveBeenWithdrawn'))
          return false
        }
        // if (!isAudit && row.recallProgress !== ChargeConstants.WE_RECALL_TO_BE_REFUSED.code) {
        //   this.$message.warning(this.$t('FinanceManage.selectBeConfirmedChargeByUs'))
        //   return false
        // }
        if (trustFromCharges && trustFromCharges.length > 0) {
          const fromCharge = trustFromCharges.find(p => p.trustFromCharge === row.chargeUuid)
          if (fromCharge && (Number(fromCharge.verifiedAmount) !== 0 || fromCharge.billingUuid || fromCharge.billingPaymentUuid ||
            fromCharge.invoiceUuid || fromCharge.confirmBillUuid || fromCharge.confirmState > 0)) {
            this.$message.warning(this.$t('FinanceManage.theFeeHasEnteredTheSettlementProcess'))
            return false
          }
        }
        if (charges && charges.length > 0) {
          const charge = charges.find(p => p.uuid === row.chargeUuid)
          if (charge && (Number(charge.verifiedAmount) !== 0 || charge.billingUuid || charge.billingPaymentUuid ||
            charge.invoiceUuid || charge.confirmBillUuid || charge.confirmState > 0)) {
            this.$message.warning(this.$t('FinanceManage.theFeeHasEnteredTheSettlementProcess'))
            return false
          }
        }
      }
      return true
    }
  }
}
</script>
